<style lang="less">
.dialog {
	border-radius: 8px;
	.el-dialog__title {
		font-size: 20px;
		font-weight: 600;
		line-height: 28px;
	}
	.el-dialog__close {
		font-size: 20px !important;
		font-weight: 600 !important;
		line-height: 30px;
	}
	.el-dialog__header {
		border-bottom: 1px solid #e4e5ea;
		padding-bottom: 24px;
		padding-top: 24px;
	}
	.el-dialog__footer {
		padding: 18px 32px 18px 18px;
		border-top: 1px solid #e4e5ea;
	}
}
.max-content {
	width: max-content !important;
}
.body-no-padding {
	.el-dialog__body {
		padding: 0px !important;
	}
}
</style>
// :style="{ // width: maxContent ? 'max-content' : width, // }"
<template>
	<el-dialog
		:custom-class="
			[
				maxContent ? 'dialog max-content' : 'dialog',
				bodyNoPadding ? 'body-no-padding' : '',
			].join(' ')
		"
		top="2%"
		:title="title"
		:close-on-click-modal="false"
		:modelValue="visible"
		:width="width"
		:beforeClose="dialogBeforeClose"
		:destroyOnClose="true"
	>
		<slot></slot>
		<template #footer v-if="footer">
			<span class="dialog-footer">
				<el-button @click="cancel" :loading="loading" :disabled="loading">{{
					content[0] || "取 消"
				}}</el-button>
				<el-button @click="confirm" :loading="loading" :disabled="loading" type="primary">{{
					content[1] || "确 认"
				}}</el-button>
			</span>
		</template>
	</el-dialog>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
export default defineComponent({
	emits: ["update:visible", "cancel", "confirm", "closeVisible"],
	props: {
		/**
		 * 标题
		 */
		title: {
			type: String,
			default: "",
		},

		/**
		 * 宽度
		 */
		width: {
			type: [String, Number],
			default: "30%",
		},

		/**
		 * 窗口显示
		 */
		visible: {
			type: Boolean,
			default: false,
		},

		/**
		 *
		 */
		bodyNoPadding: {
			type: Boolean,
			default: false,
		},

		/**
		 * 按钮加载
		 */
		loading: {
			type: Boolean,
			default: false,
		},

		/**
		 * 宽度自适应
		 */
		maxContent: {
			type: Boolean,
			default: false,
		},

		/**
		 * 是否显示footer
		 */
		footer: {
			type: Boolean,
			default: true,
		},

		/**
		 * 按钮文本配置
		 */
		content: {
			type: Array as PropType<string[]>,
			default: (): string[] => [],
		},

		/**
		 * 窗口关闭前的回调
		 */
		beforeClose: {
			/* eslint-disable */
			type: Function as PropType<() => void>,
			default: () => {
				return () => {};
			},
		},
	},

	setup(props, ctx) {
		/**
		 * 窗口关闭前执行回调函数
		 */
		const dialogBeforeClose = () => {
			props.beforeClose();
			ctx.emit("update:visible", false);
			ctx.emit("closeVisible", false);
		};

		/**
		 * 点击取消
		 */
		const cancel = () => {
			ctx.emit("update:visible", false);
			ctx.emit("cancel");
		};

		/**
		 * 点击确认
		 */
		const confirm = () => {
			ctx.emit("confirm");
		};

		return {
			dialogBeforeClose,
			cancel,
			confirm,
		};
	},
});
</script>
